module.exports = __webpack_public_path__ + "static/img/アセット 26@2x.754da74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 26@2x.png
// module id = kykR
// module chunks = 1